import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
	type ProjectType,
} from '@atlassian/jira-common-constants/src/project-types';
import type { ProjectKey } from '@atlassian/jira-shared-types';

export const GIN_SEARCH_URL = '/issues/';

export const generateNinBasePath = (
	projectKey: ProjectKey,
	projectType: ProjectType,
	isSimplifiedProject: boolean,
) => {
	const getMainPath = (projectPath: string, simplified = true) =>
		`/jira/${projectPath}${!simplified ? '/c' : ''}/projects/${projectKey}/issues`;

	switch (projectType) {
		case CORE_PROJECT:
			return getMainPath('core');
		case SERVICE_DESK_PROJECT:
			return getMainPath('servicedesk');
		case SOFTWARE_PROJECT:
			return getMainPath('software', isSimplifiedProject);
		default:
			return GIN_SEARCH_URL; // Fall back to GIN
	}
};
